import React from 'react';
import { useIntl } from 'react-intl';

import { Filters_DEPRECATED } from '~/components/Shared/Filters_DEPRECATED/Filters_DEPRECATED';
import { Field } from '~/components/Shared/Filters_DEPRECATED/types';
import { Filter } from '~/evifields/src/types/Filter';

import { getOptionLabels } from './getOptionLabels';
import { Operation } from './types';
import { getFields } from './utils';

interface Props {
  filters: Filter[];
  onChange: (updatedFilters: Filter[]) => void;
}
export const AuditLogsFilters = ({ filters, onChange }: Props) => {
  const intl = useIntl();
  const selectedOperation = filters[0]?.values?.[0] as Operation;
  const { operationOptions, entityOptions } = getOptionLabels(intl);
  const fields: Record<string, Field> = getFields({
    selectedOperation,
    intl,
    operationOptions,
    entityOptions,
  });

  return (
    <Filters_DEPRECATED
      fields={fields}
      filters={filters}
      groups={[]}
      options={{
        showInlineManageFilters: true,
        disableManageFilters: true,
        disableRemoveFilter: true,
        disableClearFilters: true,
      }}
      onChange={onChange}
    />
  );
};
